var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 18,
    viewBox: "0 0 64 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.992 17L4.152 12.272H12.984L15.144 17H17.064L9.768 0.92H7.392L0.12 17H1.992ZM7.608 4.64L8.472 2.552H8.616L9.504 4.64L12.288 10.736H4.848L7.608 4.64ZM25.1717 17L30.8357 5.144H28.9877L24.2117 15.32H24.0677L19.2677 5.144H17.4197L23.0837 17H25.1717ZM34.2221 3.632V0.92H32.5181V3.632H34.2221ZM34.2221 17V5.144H32.5181V17H34.2221ZM42.8964 17.24C46.7844 17.24 49.3524 14.672 49.3524 11.072C49.3524 7.472 46.7844 4.904 42.8964 4.904C39.0324 4.904 36.4644 7.472 36.4644 11.072C36.4644 14.672 39.0324 17.24 42.8964 17.24ZM42.8964 15.704C39.6324 15.704 38.1444 13.952 38.1444 11.072C38.1444 8.216 39.6324 6.44 42.8964 6.44C46.1604 6.44 47.6724 8.216 47.6724 11.072C47.6724 13.952 46.1604 15.704 42.8964 15.704ZM53.3237 17V11.264C53.3237 8.216 54.8357 6.464 57.7157 6.464C60.4277 6.464 61.6037 7.88 61.6037 10.328V17H63.3077V10.088C63.3077 7.28 61.6517 4.904 58.3157 4.904C55.3637 4.904 53.6837 6.848 53.2757 8.864H53.1557V5.144H51.6197V17H53.3237Z",
    fill: "#22202E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvion);
export default __webpack_public_path__ + "static/media/Avion.2936264a59104d9eab909b05b359f5f5.svg";
export { ForwardRef as ReactComponent };